import { ActionReducerMapBuilder } from '@reduxjs/toolkit'

import { appendComment, confirmAllComments, createComment, deleteComment, toggleConfirmComment } from '@/stores/slices/Labeling/thunks/comment'
import { LabelingState } from '@/stores/slices/Labeling/types'
import {
  createInitialCommentObject,
  updateAppendComment,
  updateConfirmAllComments,
  updateDeleteComment,
  updateToggleConfirmComment
} from '@/stores/slices/Labeling/reducers/common'

export const commentExtraReducers = (builder: ActionReducerMapBuilder<LabelingState>) => {
  builder.addCase(createComment.fulfilled, (state, action) => {
    createInitialCommentObject(state, action.payload)
  })
  builder.addCase(appendComment.fulfilled, (state, action) => {
    updateAppendComment(state, action.payload)
  })
  builder.addCase(deleteComment.fulfilled, (state, action) => {
    updateDeleteComment(state, action.payload)
  })
  builder.addCase(toggleConfirmComment.fulfilled, (state, action) => {
    updateToggleConfirmComment(state, action.payload)
  })
  builder.addCase(confirmAllComments.fulfilled, (state, action) => {
    updateConfirmAllComments(state, {
      shouldCompleteReview: action.payload.shouldCompleteReview,
      labelingItemId: action.payload.labelingItemId,
    })
  })
}
